import cn from 'classnames'
import React from 'react'
import { Typography } from '../components/typography'

export function wrapTextChildrenWithTypography(
  children: React.ReactNode | React.ReactNode[],
  className?: string,
) {
  const childArray = Array.isArray(children) ? children : [children]

  return childArray
    .filter(child => Boolean(child))
    .map((child) => {
      return (
        React.isValidElement(child)
          ? child
          : <Typography as="span" className={cn(className)} key={`${child}`}>{child}</Typography>
      )
    })
}
